import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=65d465e1&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"
import style0 from "./uploader.vue?vue&type=style&index=0&id=65d465e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d465e1",
  null
  
)

export default component.exports